import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Divider,
    Grid,
    IconButton,
    Link,
    Stack,
    Typography
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import React, {useState} from "react";
import {EditorContent} from "../../editor/EditorContent";
import {InternalAffairsVoterDetail} from "../InternalAffairsVoterDetail";
import {genericArrayItemUpdate} from "../../../utils";
import {Link as RouterLink} from "react-router-dom";
import {InternalAffairsComplaintResponse} from "../../../data/internal-affairs/InternalAffairsComplaintResponse";

interface expandedVoter {
    communityId: string,
    expanded: boolean
}

interface SeniorCCBannerProps {
    complaint: InternalAffairsComplaintResponse
}

export const SeniorCCReview = (props: SeniorCCBannerProps) => {
    const [expanded, setExpanded] = useState(false)
    const [expandedVoters, setExpandedVoters] = useState<expandedVoter[]>([])

    function findExpandedSate(idx: string): boolean {
        return expandedVoters.find(T => {return T.communityId === idx})?.expanded ?? false
    }

    function isAlreadyRegistered(communityId: string): boolean {
        return expandedVoters.find(T => {return T.communityId === communityId}) !== undefined
    }

    return <>
        <Accordion expanded={expanded}>
            <AccordionSummary>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Stack spacing={2} direction={"row"} sx={{display: "flex", alignItems: "center", overflowX: "auto"}}>
                            <Typography variant={"subtitle1"}>
                                <Typography sx={{pt: 2}} variant="h6" gutterBottom>Senior CC Review</Typography>
                            </Typography>
                            <IconButton
                                sx={{height: "30px", width: "30px"}}
                                color="primary"
                                onClick={() => setExpanded(!expanded)}
                            >
                                {expanded ? <VisibilityIcon/> : <VisibilityOffIcon/>}
                            </IconButton>
                        </Stack>
                    </Grid>
                </Grid>
            </AccordionSummary>
            <AccordionDetails>
                <Typography sx={{pt: 2}} variant="h6" gutterBottom>Investigator Final Report</Typography>
                <Divider />
                <EditorContent content={props.complaint.finalReport.content} />
                <Divider />
                <Typography sx={{pt: 2, overflowX: "auto"}} variant="h6" gutterBottom>Vote Results</Typography>
                <Grid container spacing={2} sx={{overflowX: "auto"}}>
                    {props.complaint.votes && props.complaint.votes.map((vote, idx) => {
                        let expandedVoterDetail = {communityId: vote.communityId, expanded: false}
                        if (!isAlreadyRegistered(vote.communityId) && Number(vote.communityId) > 0) {
                            setExpandedVoters([...expandedVoters, ...[expandedVoterDetail]])
                        }
                        let votedText
                        if (vote.voted === false) {
                            votedText = <Typography color={"error"}>(Did Not Vote)</Typography>
                        } else if (vote.voted === true) {
                            votedText = <Typography>(Voted)</Typography>
                        } else if (vote.voted === null) {
                            votedText = <Typography>(Awaiting Vote)</Typography>
                        }

                        return <Grid key={idx} item xs={4} md={4} lg={4} xl={4}>
                            <Accordion sx={{overflowX: "auto"}} expanded={findExpandedSate(vote.communityId)}>
                                <AccordionSummary>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Stack spacing={1} direction={"row"} sx={{display: "flex", alignItems: "center"}}>
                                                {Number(vote.communityId) > 0 ? <Link underline="none" component={RouterLink} to={`/user/${vote.communityId}`}>
                                                    {vote.nick}
                                                </Link> : <Typography>{vote.nick}</Typography> }
                                                {votedText}
                                                {vote.outcome !== null ? <IconButton
                                                    sx={{height: "30px", width: "30px"}}
                                                    color="primary"
                                                    onClick={() => {
                                                        setExpandedVoters(genericArrayItemUpdate(
                                                            expandedVoters,
                                                            "communityId",
                                                            vote.communityId,
                                                            "expanded",
                                                            !findExpandedSate(vote.communityId)
                                                        ))
                                                    }}
                                                >
                                                    {findExpandedSate(vote.communityId) ? <VisibilityIcon/> : <VisibilityOffIcon/>}
                                                </IconButton> : <></>}
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails><InternalAffairsVoterDetail data={vote}/></AccordionDetails>
                            </Accordion>
                        </Grid>
                    })}
                </Grid>
            </AccordionDetails>
        </Accordion>
    </>
}